import { render, staticRenderFns } from "./VFormFileInput.vue?vue&type=template&id=12fd98d8&scoped=true&"
import script from "./VFormFileInput.vue?vue&type=script&lang=js&"
export * from "./VFormFileInput.vue?vue&type=script&lang=js&"
import style0 from "./VFormFileInput.vue?vue&type=style&index=0&id=12fd98d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd98d8",
  null
  
)

export default component.exports